import WorkerTag from "./WorkerTag";

export default WorkerTag;
